import type { IconNode } from '../types';

/**
 * @name bee-hive
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTAiIGhlaWdodD0iNCIgeD0iNyIgeT0iMiIgcng9IjIiIC8+CiAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjQiIHg9IjQiIHk9IjYiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Ik0xNCAxNGg2YTIgMiAwIDEgMCAwLTRINGEyIDIgMCAxIDAgMCA0aDYiIC8+CiAgPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iOCIgeD0iMTAiIHk9IjEwIiByeD0iMiIgLz4KICA8cGF0aCBkPSJNMTkgMTRhMiAyIDAgMSAxIDAgNEg1YTIgMiAwIDEgMSAwLTQiIC8+CiAgPHJlY3Qgd2lkdGg9IjE0IiBoZWlnaHQ9IjQiIHg9IjUiIHk9IjE4IiByeD0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bee-hive
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const beeHive: IconNode = [
  ['rect', { width: '10', height: '4', x: '7', y: '2', rx: '2', key: '9e5utf' }],
  ['rect', { width: '16', height: '4', x: '4', y: '6', rx: '2', key: '13t5kn' }],
  ['path', { d: 'M14 14h6a2 2 0 1 0 0-4H4a2 2 0 1 0 0 4h6', key: 'mvjpwm' }],
  ['rect', { width: '4', height: '8', x: '10', y: '10', rx: '2', key: 'uo6s9r' }],
  ['path', { d: 'M19 14a2 2 0 1 1 0 4H5a2 2 0 1 1 0-4', key: 'xqcbgq' }],
  ['rect', { width: '14', height: '4', x: '5', y: '18', rx: '2', key: '4j3ov2' }],
];

export default beeHive;
